import {
  Accordion,
  Flex,
  Text,
  TypographyStylesProvider,
  useMantineTheme,
} from "@mantine/core";
import BoxShop from "./Box";
import {
  EProductType,
  IMyPlans,
} from "../../../../interfaces/MyPlans/IMyPlans";
import { client_selected } from "../../../../client";
import { formatCurrency } from "../../../../utils/currency";
import { useTranslation } from "react-i18next";
import { convertProductType } from "../../../../utils/convertProductType";
import { convertRecurrencyType } from "../../../../utils/convertRecurrencyType";

interface IProps {
  product: IMyPlans;
}

const AccordionInfo = ({ product }: IProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const name = client_selected.name || "----";
  const hasFinancial = client_selected.hasFinancial;

  const recurrencyType = t(
    convertRecurrencyType(product?.plan?.recurrency_type)
  );

  const productType = convertProductType(
    (product?.product?.type as EProductType) || ""
  );

  return (
    <Accordion.Item value="Info">
      <Accordion.Control p="0">
        <Flex direction={"column"} gap={16} w={"100%"}>
          <Flex
            id="lineTwoCardProduct"
            gap={32}
            direction={{ base: "column", 991: "row" }}
          >
            <Flex gap={16} wrap="wrap" w="100%" justify={"space-between"}>
              <BoxShop
                title={t(
                  "meu_portfolio.minhas_compras.card_product.accordion_info.sell_by"
                )}
                content={product?.whitelabel?.name || name}
              />
              <BoxShop
                title={t(
                  "meu_portfolio.minhas_compras.card_product.accordion_info.periodicity"
                )}
                content={recurrencyType}
              />
              {!!product?.plan ? (
                <BoxShop
                  title={t(
                    "meu_portfolio.minhas_compras.card_product.accordion_info.plan"
                  )}
                  content={
                    product?.plan?.name === "Ilimitado"
                      ? product?.plan?.name
                      : `${product?.plan?.name}${
                          !!product?.plan?.qty_contract
                            ? t(
                                "meu_portfolio.minhas_compras.card_product.accordion_info.limit",
                                {
                                  qty_contract: product?.plan?.qty_contract,
                                }
                              )
                            : ""
                        }`
                  }
                />
              ) : null}
              <BoxShop
                title={t(
                  "meu_portfolio.minhas_compras.card_product.accordion_info.market"
                )}
                content={product?.product?.market || "----"}
              />
              <BoxShop
                title={t(
                  "meu_portfolio.minhas_compras.card_product.accordion_info.product_type"
                )}
                content={t(productType)}
              />
              {hasFinancial ? (
                <>
                  <BoxShop
                    title={t(
                      "meu_portfolio.minhas_compras.card_product.accordion_info.payment_method"
                    )}
                    content={t(
                      "meu_portfolio.minhas_compras.card_product.accordion_info.credit_card"
                    )}
                  />
                  <BoxShop
                    title={t(
                      "meu_portfolio.minhas_compras.card_product.accordion_info.value"
                    )}
                    content={formatCurrency(product?.plan?.price)}
                  />
                </>
              ) : null}
            </Flex>
          </Flex>
        </Flex>
      </Accordion.Control>
      <Accordion.Panel
        styles={{
          ".content": {
            padding: "0px",
          },
        }}
      >
        <TypographyStylesProvider style={{}}>
          <Text fs="14px" c={theme.colors.basic[5]} fw={600}>
            {t(
              "meu_portfolio.minhas_compras.card_product.accordion_info.description"
            )}
          </Text>
          <Text
            ff="barlow"
            lh="32px"
            color="basic.4"
            dangerouslySetInnerHTML={{
              __html: product?.product?.short_description || "",
            }}
          />
        </TypographyStylesProvider>
      </Accordion.Panel>
    </Accordion.Item>
  );
};
export default AccordionInfo;
